module.exports = __webpack_public_path__ + "img/burger-cheese.da809090.svg";